import type { conversationStateValues } from '../conversations/conversations.typings';
import { getCallFromConversationID } from '../conversations/utils';
import type { RCSState } from '../rcs/rcsSlice';
import type { TextFrom911State } from '../textFrom911/textFrom911Slice';

export interface StateWithConversationSlices {
  /** Outbound 911 text. */
  textFrom911: TextFrom911State;
  /** TT911 and admin line. */
  conversations: Record<string, conversationStateValues>;
  rcs: RCSState;
}

const findByConversationID = <
  T extends { data?: { conversation_id?: string | null } | null },
>(
  conversations: Record<string, T>,
  conversationID: string,
): string | null =>
  Object.keys(conversations).find(
    callerID =>
      conversations[callerID]?.data?.conversation_id === conversationID,
  ) ?? null;

/**
 * Null for conversations tied to no call — interagency, collaborator and
 * agency-share arrive on the same session and have to fall through.
 */
export const selectCallerIDForConversationID = (
  state: StateWithConversationSlices,
  conversationID?: string | null,
): string | null => {
  if (!conversationID) return null;
  return (
    findByConversationID(state.textFrom911.conversations, conversationID) ??
    // The conversations slice is a union whose id location varies by source.
    getCallFromConversationID(conversationID, state.conversations) ??
    findByConversationID(state.rcs.conversations, conversationID)
  );
};
